// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// @mui outlined icons — thin line-art to match the Airbnb category breakdown
import CleaningServicesOutlined from "@mui/icons-material/CleaningServicesOutlined";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import KeyOutlined from "@mui/icons-material/KeyOutlined";
import ChatBubbleOutlineOutlined from "@mui/icons-material/ChatBubbleOutlineOutlined";
import MapOutlined from "@mui/icons-material/MapOutlined";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Airbnb category ratings from the listing.
const categories = [
  { label: "Cleanliness", score: "4.9", Icon: CleaningServicesOutlined },
  { label: "Accuracy", score: "4.9", Icon: CheckCircleOutlined },
  { label: "Check-in", score: "5.0", Icon: KeyOutlined },
  { label: "Communication", score: "5.0", Icon: ChatBubbleOutlineOutlined },
  { label: "Location", score: "4.9", Icon: MapOutlined },
  { label: "Value", score: "5.0", Icon: LocalOfferOutlined },
];

function CategoryRatings() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={10} sx={{ mx: "auto" }}>
          {categories.map(({ label, score, Icon }, i) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={2}
              key={label}
              sx={{
                borderLeft: { xs: "none", md: i === 0 ? "none" : "1px solid" },
                borderColor: "grey.300",
              }}
            >
              <MKBox px={{ xs: 0.5, md: 2 }} py={1.5}>
                <MKTypography variant="body2" fontWeight="bold" color="dark">
                  {label}
                </MKTypography>
                <MKTypography variant="h4" fontWeight="bold" color="dark" mt={0.25} mb={1.5}>
                  {score}
                </MKTypography>
                <Icon sx={{ fontSize: "1.9rem", color: "dark.main" }} />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CategoryRatings;
